import React, { useEffect } from "react";
import {
  FilterProps,
} from "react-table";
import PlateUtil from "../../Utility/PlateUtil";
import { SelectColumnFilter } from "../Common/CommonTable";

export function PlateAdressStatusColumnFilter<T extends object>(props: FilterProps<T>) {
  
  const staticFilter = PlateUtil.getPlateAdressStatusFilter();

  return <SelectColumnFilter {...props} staticFilter={staticFilter} selectId="plate-address-drop-down"/>
}
